<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Aquila urlante</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Normalmente, quando un vino arriva a migliaia all'asta, ti aspetteresti che il vino in questione sia a) molto vecchio eb) molto francese. Quindi, quando una bottiglia Imperiale da 6 litri di Screaming Eagle Cabernet Sauvignon del 1992 è stata venduta per $ 500.000 nel 2000 (il vino aveva solo otto anni all'epoca!), Ha sollevato più di qualche sopracciglio.
                    </div>

                    <div class="howto-title2">Un vino magico, mistico</div>
                    <div class="howto-text">
                        Guadagnandosi il titolo di bottiglia di vino più costosa d'America, il Sauvignon Blanc ha un
                        prezzo medio di 5.400 euro a bottiglia sul mercato secondario mentre il Cabernet Sauvignon fa irruzione
                        a un prezzo medio di tutto rispetto di € 3.300, Screaming Eagle è uno dei migliori al mondo
                        vini ambiti. La tenuta è avvolta nel mistero; le interviste non vengono mai rilasciate, i tour in cantina sono a
                        no go e anche la produzione annua di 500 casse (da soli 57 acri di vigneto) e 12 anni
                        lista d'attesa sono solo supposizioni plausibili da parte di coloro che ne sono a conoscenza. Questi ovviamente rafforzano solo il
                        stato leggendario delle proprietà. Quello che sappiamo è che è di proprietà del miliardario Stan Kroenke (proprietario
                        dei Los Angeles Rams e della squadra di calcio dell'Arsenal) e il suo enologo è il ragazzo prodigio Nick
                        Gislason, subentrato ad Andy Erickson nel 2010 a soli 28 anni.
                    </div>

                    <div class="howto-title2">Un caso dei vestiti nuovi dell'Imperatore?</div>
                    <div class="howto-text">
                        Il vino ha raggiunto le sue vette vertiginose dopo che il superfan Robert Parker ha dato il primo a Screaming Eagle
                        Annata 1992 i quasi perfetti 99 punti. Questo divenne presto il perfetto 100 per il magico 2007,
                        Vendemmia 2010 e 2012. Tuttavia, questo ha sollevato alcune polemiche; Parker non ha un sapore cieco
                        ed è impossibile essere imparziali sullo status del vino. Questo ha portato alcuni critici a credere
                        che il vino, sebbene molto, molto buono, non vale il suo enorme prezzo.
                        <br><br>
                        Indipendentemente dal fatto che il vino valga il suo prezzo per essere bevuto, è certo che come an
                        opzione di vino investibile, è un gioco da ragazzi. Rilasciato a $ 800 (€ 710), il prezzo raddoppia il
                        istante colpisce il mercato secondario. Gli investitori possono trovare valore nell'annata 2016 ma per l'età
                        capacità, il 2012 da 100 punti è forse l'opzione migliore.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Screaming Eagle</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn bei einer Auktion ein Wein in die Tausende geht, geht man normalerweise davon aus, dass der betreffende Wein a) sehr alt und b) sehr französisch ist. Als im Jahr 2000 eine 6-Liter-Imperial-Flasche Screaming Eagle Cabernet Sauvignon aus dem Jahr 1992 für 500.000 US-Dollar verkauft wurde (der Wein war damals erst acht Jahre alt!), zog das mehr als nur ein paar Augenbrauen hoch.
                    </div>

                    <div class="howto-title2">Ein magischer, mystischer Wein</div>
                    <div class="howto-text">
                        Der Sauvignon Blanc hat sich den Titel Amerikas teuerste Flasche Wein verdient
                        Durchschnittspreis von 5.400 € pro Flasche auf dem Sekundärmarkt, während der Cabernet Sauvignon stürmt
                        Mit einem sehr respektablen Durchschnittspreis von 3.300 € ist Screaming Eagle einer der besten der Welt
                        begehrte Weine. Das Anwesen ist voller Geheimnisse; Interviews werden nie gegeben, Kellerführungen sind eine
                        no go und sogar die 500-jährige Kistenproduktion (von nur 57 Hektar Weinberg) und 12-jährige
                        Wartelisten sind lediglich fundierte Vermutungen von Kennern. Diese stärken natürlich nur die
                        legendären Status des Anwesens. Was wir wissen ist, dass es dem Milliardär Stan Kroenke (Eigentümer) gehört
                        (Mitglied des Footballclubs Los Angeles Rams und Arsenal) und sein Winzer ist der Wunderknabe Nick
                        Gislason, der 2010 mit gerade einmal 28 Jahren die Nachfolge von Andy Erickson antrat.
                    </div>

                    <div class="howto-title2">Eine Kiste mit den neuen Kleidern des Kaisers?</div>
                    <div class="howto-text">
                        Der Wein erreichte seinen schwindelerregenden Höhepunkt, nachdem Superfan Robert Parker Screaming Eagle’s zum ersten Mal gab
                        Jahrgang 1992 die nahezu perfekten 99 Punkte. Dies war bald die perfekte 100 für das magische Jahr 2007.
                        Jahrgang 2010 und 2012. Dies hat jedoch einige Kontroversen ausgelöst; Parker schmeckt nicht blind
                        und es ist unmöglich, gegenüber dem Status des Weins unparteiisch zu sein. Dies hat einige Kritiker zu dieser Annahme verleitet
                        dass der Wein zwar sehr, sehr gut, aber seinen hohen Preis nicht wert ist.
                        <br><br>
                        Unabhängig davon, ob der Wein seinen Preis wert ist, ist es sicher, dass er als Wein getrunken wird
                        Da es sich um eine investierbare Weinoption handelt, ist das ein Kinderspiel. Bei 800 US-Dollar (710 Euro) verdoppelt sich der Preis
                        Sobald es auf den Sekundärmarkt gelangt. Für Anleger mag der Jahrgang 2016 von Wert sein, allerdings aufgrund seines Alters
                        Fähigkeit, die 100 Punkte 2012 ist vielleicht die beste Option.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Aigle hurlant</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Normalement, lorsqu'un vin atteint des milliers aux enchères, on s'attendrait à ce que le vin en question soit a) très vieux et b) très français. Ainsi, lorsqu'une bouteille impériale de 6 litres de Screaming Eagle Cabernet Sauvignon 1992 s'est vendue 500 000 $ en 2000 (le vin n'avait que huit ans à l'époque !), cela a soulevé plus d'un sourcil.
                    </div>

                    <div class="howto-title2">Un vin magique et mystique</div>
                    <div class="howto-text">
                        Gagner le titre de la bouteille de vin la plus chère d'Amérique - le Sauvignon Blanc a un
                        prix moyen de 5 400 € la bouteille sur le second marché alors que le Cabernet Sauvignon prend d'assaut
                        à un prix moyen très respectable de 3 300 €, Screaming Eagle est l'un des plus
                        vins convoités. Le domaine est entouré de mystère; les entretiens ne sont jamais donnés, les visites de caves sont un
                        pas aller et même la production annuelle de 500 caisses (à partir de seulement 57 acres de vignoble) et 12 ans
                        liste d'attente ne sont que des suppositions éclairées par les connaisseurs. Ceux-ci ne font bien sûr que renforcer la
                        statut légendaire des domaines. Ce que nous savons, c'est qu'il appartient au milliardaire Stan Kroenke (propriétaire
                        du club de football Los Angeles Rams et Arsenal) et son vigneron est le garçon prodige Nick
                        Gislason, qui a succédé à Andy Erickson en 2010, n'a que 28 ans.
                    </div>

                    <div class="howto-title2">Une caisse de vêtements neufs de l'Empereur?</div>
                    <div class="howto-text">
                        Le vin a atteint ses sommets vertigineux après que le superfan Robert Parker ait donné le premier de Screaming Eagle
                        Millésime 1992 le presque parfait 99 points. C'est vite devenu le 100 parfait pour la magie 2007,
                        Millésime 2010 et 2012. Cependant, cela a soulevé une certaine controverse; Parker ne goûte pas à l'aveugle
                        et il est impossible d'être impartial sur le statut du vin. Cela a conduit certains critiques à croire
                        que le vin, bien que très, très bon, ne vaut pas son prix exorbitant.
                        <br><br>
                        Peu importe si le vin vaut son prix à boire, il est certain qu'en tant que
                        option de vin investissable, c'est une évidence. Sorti à 800$ (710€), le prix double le
                        instant il frappe le marché secondaire. Les investisseurs peuvent trouver de la valeur dans le millésime 2016 mais pour l'âge
                        capacité, le 100 points 2012 est peut-être la meilleure option.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Screaming Eagle</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Normally, when a wine reaches into the thousands at auction, you would expect the wine in question to be a) very old and b) very French. So when a 6-litre Imperial bottle of 1992 Screaming Eagle Cabernet Sauvignon sold for $500,000 in 2000 (the wine was just eight years old at the time!), it raised more than a few eyebrows.
                    </div>

                    <div class="howto-title2">A magical, mystical wine</div>
                    <div class="howto-text">
                        Earning the title of America’s most expensive bottle of wine - the Sauvignon Blanc has an
                        average price of €5,400 per bottle on the secondary market while the Cabernet Sauvignon storms
                        in at a very respectable €3,300 average price, Screaming Eagle is one of the world’s most
                        coveted wines. The estate is shrouded in mystery; interviews are never given, cellar tours are a
                        no go and even the 500 annual case production (from just 57-acres of vineyard) and 12-year
                        waiting list are just educated guesses by those in the know. These of course only bolster the
                        estates legendary status. What we do know is that it is owned by billionaire Stan Kroenke (owner
                        of the Los Angeles Rams and Arsenal football club) and its winemaker is the boy-wonder Nick
                        Gislason, who took over from Andy Erickson in 2010 just 28.
                    </div>

                    <div class="howto-title2">A case of the Emporer’s new clothes?</div>
                    <div class="howto-text">
                        The wine reached its giddy heights after superfan Robert Parker gave Screaming Eagle’s first
                        1992 vintage the near perfect 99 points. This soon became the perfect 100 for the magic 2007,
                        2010 and 2012 vintage. However, this has raised some controversy; Parker does not taste blind
                        and it is impossible to be impartial to the wine’s status. This has led some critic to believe
                        that the wine, while very, very good, is not worth its huge price.
                        <br><br>
                        Regardless of whether the wine is worth its price for drinking, it is certain that as an
                        investable wine option, it is a no brainer. Released at $800 (€710), the price doubles the
                        instant it hits the secondary market. Investors may find value in the 2016 vintage but for age
                        ability, the 100-point 2012 is perhaps the best option.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ScreamingEagle",
    head: {
        title: 'Screaming Eagle | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the pinnacle of luxury wine with Screaming Eagle, a renowned Napa Valley wine producer known for crafting exceptional Cabernet Sauvignon. Experience the elegance and sophistication of one of the world\'s top wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
